"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GenericUSDManager = exports.APICache = exports.GlobalCache = exports.MockUsdManager = exports.AssistedAuthenticator = exports.AssistedSession = exports.UsdManager = exports.EnvVariables = exports.DRPicasoAuthenticatorAsis = exports.DRPicasoSessionAsis = exports.AsisAuthenticator = exports.DRPicasoAuthenticator = exports.DRPicasoSession = exports.USDAuthenticator = exports.USDSession = exports.CCDevAuthenticator = exports.CCDevSession = exports.AsisSession = exports.TimeOut = exports.Authoriser = exports.API = exports.HybridAuthenticator = exports.HybridSession = exports.Authenticator = exports.Session = exports.configureFramework = void 0;
/**
 * FIXME: this import shouldn't be necessary, but if we remove it the build types get fucked up when
 * working with moduleResolution: bundler in the client
 */
const base_1 = require("./base");
Object.defineProperty(exports, "configureFramework", { enumerable: true, get: function () { return base_1.configureFramework; } });
const xhrNotifyAsisPlugin_1 = require("../xhr/plugins/asis/xhrNotifyAsisPlugin");
const { Session, Authenticator, HybridSession, HybridAuthenticator, API, Authoriser, TimeOut, AsisSession, CCDevSession, CCDevAuthenticator, USDSession, USDAuthenticator, DRPicasoSession, DRPicasoAuthenticator, AsisAuthenticator, DRPicasoSessionAsis, DRPicasoAuthenticatorAsis, EnvVariables, UsdManager, AssistedSession, AssistedAuthenticator, MockUsdManager, GlobalCache, APICache, GenericUSDManager, } = (0, base_1.configureFramework)('OK_ES', 'es-ES', { additionalPlugins: [new xhrNotifyAsisPlugin_1.XHRNotifyAsisPlugin()] });
exports.Session = Session;
exports.Authenticator = Authenticator;
exports.HybridSession = HybridSession;
exports.HybridAuthenticator = HybridAuthenticator;
exports.API = API;
exports.Authoriser = Authoriser;
exports.TimeOut = TimeOut;
exports.AsisSession = AsisSession;
exports.CCDevSession = CCDevSession;
exports.CCDevAuthenticator = CCDevAuthenticator;
exports.USDSession = USDSession;
exports.USDAuthenticator = USDAuthenticator;
exports.DRPicasoSession = DRPicasoSession;
exports.DRPicasoAuthenticator = DRPicasoAuthenticator;
exports.AsisAuthenticator = AsisAuthenticator;
exports.DRPicasoSessionAsis = DRPicasoSessionAsis;
exports.DRPicasoAuthenticatorAsis = DRPicasoAuthenticatorAsis;
exports.EnvVariables = EnvVariables;
exports.UsdManager = UsdManager;
exports.AssistedSession = AssistedSession;
exports.AssistedAuthenticator = AssistedAuthenticator;
exports.MockUsdManager = MockUsdManager;
exports.GlobalCache = GlobalCache;
exports.APICache = APICache;
exports.GenericUSDManager = GenericUSDManager;
//# sourceMappingURL=index.js.map